<template>
    <div class="content-wrap">
        <div class="content">
            <div class="content-item flb">
                <div class="content-item-name">推荐客户姓名</div>
                <div>
                    <input type="text" placeholder="请输入客户名称" align="right" v-model="oFrom.sName" />
                </div>
            </div>
            <div class="content-item flb">
                <div class="content-item-name">手机号码</div>
                <div style="width: 50%">
                    <input style="width: 100%" type="number" align="right" placeholder="请输入客户手机号码" v-model="oFrom.sPhone">
                </div>
            </div>
            <div class="content-item flb">
                <div class="content-item-name">选择城市</div>
                <div class="flb content-item-right" @click="selectCity">
                    <div>{{ sCity || '请选择' }}</div>
                    <img src="@/assets/images/user/house/right-icon.png" alt="">
                </div>
            </div>
            <div class="content-item flb">
                <div class="content-item-name">区域</div>
                <div class="flb content-item-right" @click="selectArea">
                    <div>{{ sArea || '请选择' }}</div>
                    <img src="@/assets/images/user/house/right-icon.png" alt="">
                </div>
            </div>
            <div class="content-item flb">
                <div class="content-item-name">详细地址</div>
                <div>
                    <input type="text" placeholder="请输入详细地址" v-model="oFrom.sAddress">
                </div>
            </div>
        </div>
        <div class="border"></div>
        <div class="content">
            <div class="content-item-name remark-title">说明备注</div>
            <textarea class="advice-text" name="" id="" cols="30" rows="10" placeholder="请备注相关信息" v-model="oFrom.sRemark"></textarea>
        </div>
        <!--提交按钮-->
        <div class="sub-btn" @click="submit">提交</div>

        <!-- <van-popup round position="bottom" v-model="popShow" > -->
        <!--<van-picker :title="selectTitle" value-key="title" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="popShow = false" />-->
        <!-- <van-area title="标题" :area-list="areaList" columns-num="2" @confirm="onConfirm" value="360100" /> -->
        <awesome-picker ref="picker" :data="arrAddressList" :colorConfirm="sColor" :colorCancel="sColor" swipeTime:500 @confirm="handlePickerConfirm" v-if="popShow"></awesome-picker>
        <!-- </van-popup> -->
    </div>
</template>

<script>
import { areaList } from '@vant/area-data';
import oAddRess from '@/js/address.js'
import oRecommend from '@/js/recommend.js'
// 我要推荐
export default {
    name: "recommend",
    created() {
        this.initAddressList()
    },
    data() {
        return {
            popShow: false,
            selectTitle: '',
            columns: [{ title: '北京', id: 1 }, { title: '上海', id: 2 }, { title: '南昌', id: 3 }],
            select: 'city',
            sCity: '',
            sArea: '',
            areaList,
            arrAddressList: [],
            sColor: "#2395ff",
            oFrom: {
                //省市区三个Id
                sProvinceId: "",
                sCityId: "",
                sDistId: "",
                sName: "",
                sPhone: "",
                sName: "",
                sAddress: "",
                sRemark: "",

            },
            //省市数据
            arrCity: [],
            //原始数据
            arrOriginal: []
        }
    },
    methods: {
        // 二级联动选择城市区域
        selectCity() {
            this.select = 'city'
            this.selectTitle = '选择城市'
            this.columns = [{ title: '北京', id: 1 }, { title: '上海', id: 2 }, { title: '南昌', id: 3 }]
            this.popShow = true
            this.arrAddressList = this.arrCity
            setTimeout(() => {
                this.$refs.picker.show();
            }, 100);
        },
        selectArea() {
            if (this.sCity) {
                this.select = 'area'
                this.selectTitle = '选择区域'
                this.columns = [{ title: '红谷滩区', id: 1 }, { title: '新建区', id: 2 }, { title: '青山湖区', id: 3 }]
                this.popShow = true
                this.arrAddressList = oAddRess.getArea(this.arrOriginal[this.oFrom.sCityId])
                //console.log(this.arrAddressList)
                setTimeout(() => {
                    this.$refs.picker.show();
                }, 100);
            } else {
                alert('先选择城市') // todo 这里要加提示
            }
        },
        onConfirm(val) {
            // console.log(val);
            if (this.select === 'city') {
                //     this.city = e.title

            } else {
                //     this.area = e.title
            }
            // this.popShow = false
            // this.$forceUpdate()
        },
        initAddressList() {
            oAddRess.getAddress(this).then(res => {
                //console.log(res)
                this.arrCity = res.city
                this.arrOriginal = res.original
            })
        },
        handlePickerConfirm(val) {
            //console.log(val)
            //根据已选的省市找去区 真是奇葩设计 非要选两次 直接三级联动不行吗 lj
            if (this.select === 'city') {
                let province = this.arrAddressList[val[0].index]
                //console.log(province)
                this.oFrom.sProvinceId = province.id
                let city = province.children[val[1].index]
                this.oFrom.sCityId = city.id
                this.sCity = province.value + city.value
                //console.log(this.sProvinceId, this.sCityId)
            } else {
                let area = this.arrAddressList[val[0].index]
                //console.log(area)
                this.sArea = area.value
                this.oFrom.sDistId = area.id

                //console.log(area)
            }
        },
        submit() {
            if (!this.oFrom.sName) {
                this.$toast("请输入客户姓名")
                return
            }
            if (!this.oFrom.sPhone) {
                this.$toast("请输入客户手机号码")
                return
            }
            if (!this.oFrom.sAddress) {
                this.$toast("请输入详细地址")
                return
            }
            let data = {
                name: this.oFrom.sName,
                phone: this.oFrom.sPhone,
                province_id: this.oFrom.sProvinceId,
                city_id: this.oFrom.sCityId,
                dist_id: this.oFrom.sDistId,
                address: this.oFrom.sAddress,
                remark: this.oFrom.sRemark,
            }
            this.$store.commit("loadSwitch", true);
            oRecommend.getReferAdd(data).then(res => {
                this.$store.commit("loadSwitch", false);
                this.$toast("添加成功")
                this.$router.replace({
                    path: '/user/house/recommend2',
                })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.content-wrap {
    background: #fff;
    min-height: 100vh;

    .content {
        padding: 0 3.2%;

        .content-item {
            border-bottom: 2px solid #f7f7f7;
            &:last-child {
                border-bottom: none;
            }

            .content-item-right {
                div {
                    font-size: $baseSize;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: $viceText;
                    line-height: 40px;
                }
                img {
                    width: 36px;
                    height: 36px;
                }
            }

            input {
                text-align: right;
                line-height: 40px;
                font-size: $baseSize;
            }
        }

        .advice-text {
            width: 100%;
            height: 248px;
            padding: 24px;
            background: #f7f7f7;
            border-radius: $commonRadius;
            resize: none;
        }

        .remark-title {
            line-height: 40px !important;
            margin-top: 30px;
            margin-bottom: 20px;
        }

        /*通用*/
        .content-item-name {
            font-size: $baseSize;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: $commonText;
            line-height: 102px;
        }
    }

    .border {
        width: 100%;
        height: 10px;
        background: #f7f7f7;
    }

    .sub-btn {
        width: 93.6%;
        height: 100px;
        background: $userBgGradient;
        border-radius: $commonRadius;
        margin: 264px auto 132px;

        font-size: $bigSize;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        line-height: 100px;
    }
}

/*通用样式*/
.flb {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
::-webkit-input-placeholder {
    font-size: 28px;
}
</style>